import Vue from 'vue'
import VueHead from 'vue-head'

import App from './App.vue'
import router from './router'
import store from './store'

/*form input check*/
import Vuelidate from 'vuelidate'

import axios from "axios"
import VueAxios from "vue-axios"
/*Dialog*/
import VuejsDialog from 'vuejs-dialog'
import 'vuejs-dialog/dist/vuejs-dialog.min.css'


/*fontawesome*/
import { library } from '@fortawesome/fontawesome-svg-core'
import { faXTwitter, faFacebook, faLine } from '@fortawesome/free-brands-svg-icons'
import { faFilter } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
library.add(faXTwitter, faFacebook, faLine, faFilter)
Vue.component('font-awesome-icon', FontAwesomeIcon)

/*vue-gtag*/
import VueGtag from 'vue-gtag'
Vue.use(VueGtag, {
  config: {
    id: 'G-JT49H3GEGB',
    params: {
      send_page_view: false
    }
  }
}, router)

/*vue-social-sharing*/
import VueSocialSharing from 'vue-social-sharing'
Vue.use(VueSocialSharing)

/*vue-image-lightbox*/
/*
import VueLazyLoad from 'vue-lazyload'
Vue.use(VueLazyLoad, {
  preLoad: 1.3,
  error: 'https://dummyimage.com/130x120/ccc/999.png&text=Not+Found',
  loading: 'https://dummyimage.com/130x120/dcdcdc/999.png&text=Now loading',
  attempt: 1
})
*/

import GlobalUse from './mixins/globalValiables'

/*RESET css, テンプレートCSSは各モジュール設定の上書きが必要なので最後に読み込む*/
import '../public/asset/css/reset.css'
/*import '../node_modules/vue-image-lightbox/dist/vue-image-lightbox.min.css'*/


import '../public/asset/css/common.css'
import '../public/asset/css/externalModule.css'
import '../public/asset/css/commonColor.css'
import '../public/asset/css/commonComponents.css'
import '../public/asset/css/commonSite.css'
import '../public/asset/css/page.css'

Vue.config.devtools = true
Vue.config.productionTip = false

Vue.use(VueHead)
Vue.use(Vuelidate)
Vue.mixin(GlobalUse)
Vue.use(VueAxios, axios)
Vue.use(VuejsDialog)


/*カスタムディレクティブ:scrollイベント*/
/*生成
注意：コンポーネント生成（mounted）前に呼ぶ（inserted）ため
rectなど正確な情報が取得できない場合がある。
*/
/*unbindで処理する方法
生成elに自滅メソッドを定義して、unbind時にel.メソッド呼び出す
*/
Vue.directive('scroll', {
//  componentUpdated: function (el, binding) {
		inserted: function (el, binding) {
    let f = function (evt) {
      if (binding.value(evt, el)) {
        window.removeEventListener('scroll', f)
      }
    }
    window.addEventListener('scroll', f)
    el.$destroy = () => window.removeEventListener('scroll', f)
  },
  unbind:function (el, binding) {
    el.$destroy()
  },
})

/*グローバル変数定義*/
var GlobalData = new Vue({
  data: {
    $changedBuffer: "",
  }
});
Vue.mixin({
  data() {
    return {
/*定数定義*/
      FirstLayer:1,
      SecondLayer:2,
      ThirdLayer:3,
      FourthLayer:4,
			PublicPath:"",
			extImageDir:"/asset/images/",
			innImageDir:"../asset/images/",
    }
  },
  methods: {

		getExtImageDir:function() {
			return this.extImageDir
		},
		getInnerImageDir:function() {
			return this.innImageDir
		},
/*イメージファイルをセットする 環境に応じたサブディレクトリをセットするだけ
ファイル名を処理すると、対象となるファイル全てが固定ファイルとなってしまう。
*/
		setImageFullPath(fileName) {
			return this.PublicPath + this.extImageDir + fileName
		},
/*スクロール背景切り替え用*/
    $_refChangedBuffer() {
      return GlobalData.$data.$changedBuffer
    },
    $_setChangedBuffer(aPhase) {
      GlobalData.$data.$changedBuffer = aPhase
    },
  },


/*
	beforeRouteEnter (to, from, next) {
		console.log('component:beforeRouteEnter', to, from);
		next();
  },
	beforeRouteUpdate (to, from, next) {
		console.log('component:beforeRouteUpdate', to, from);
		next();
	},
	beforeRouteLeave (to, from, next) {
		console.log('component:beforeRouteLeave', to, from);
		next();
	}
	*/
})

var vm = new Vue({
  el:'#app',
  router,
  store,
  render: h => h(App),
})
